import { slaSeverity1Def, slaSeverity1Name, slaSeverity2Def, slaSeverity2Name, slaSeverity3Def, slaSeverity3Name, slaSeverity4Def, slaSeverity4Name, slaTargetBusinessDays2, slaTargetBusinessDays5, slaTargetHours24 } from 'Bomdisoft/translations';
import type { Translation } from '@bomdisoft/translations';

export type SlaSeverity = {
  definition: Translation;
  level: 'S1' | 'S2' | 'S3' | 'S4';
  name: Translation;
  target: Translation;
};

export const SUPPORT_EMAIL = 'support@bomdisoft.com';

export const SLA_SEVERITIES: readonly SlaSeverity[] = [
  { definition: slaSeverity1Def, level: 'S1', name: slaSeverity1Name, target: slaTargetHours24 },
  { definition: slaSeverity2Def, level: 'S2', name: slaSeverity2Name, target: slaTargetBusinessDays2 },
  { definition: slaSeverity3Def, level: 'S3', name: slaSeverity3Name, target: slaTargetBusinessDays5 },
  { definition: slaSeverity4Def, level: 'S4', name: slaSeverity4Name, target: slaTargetBusinessDays5 },
];
